module.exports = __webpack_public_path__ + "static/media/Krombacher-SansDemiItalic.42c90987.otf";